// import React, { useState } from 'react';

// const NtxTest = ({ onSubmit }: { onSubmit: any }) => {
//   const [input, setInput] = useState('');

//   const handleClick = (value: any) => {
//     setInput(prev => prev + value);
//   };

//   const handleBackspace = () => {
//     setInput(prev => prev.slice(0, -1));
//   };

//   const handleClear = () => {
//     setInput('');
//   };

//   const handleSubmit = () => {
//     onSubmit(input);
//   };

//   return (
//     <>
//       <div className='keypad-container'>
//         <input className='display-input' value={input} readOnly />

//         <div className='keypad-grid'>
//           <button onClick={handleBackspace}>⌫</button>
//           <button onClick={handleClear}>✖</button>
//           <button className='confirm-btn' onClick={handleSubmit}>
//             ✔
//           </button>

//           {[9, 8, 7, 6, 5, 4, 3, 2, 1].map(num => (
//             <button key={num} onClick={() => handleClick(num.toString())}>
//               {num}
//             </button>
//           ))}

//           <button onClick={() => handleClick('.')}>.</button>
//           <button onClick={() => handleClick('0')}>0</button>
//         </div>
//       </div>
//       <style>
//         {`
//           .keypad-container {
//   width: 300px;
//   padding: 1rem;
//   background: white;
//   border-radius: 10px;
//   box-shadow: 0 0 10px #ccc;
// }

// .display-input {
//   width: 100%;
//   font-size: 1.5rem;
//   text-align: right;
//   padding: 0.5rem;
//   border: 2px solid teal;
//   border-radius: 5px;
//   margin-bottom: 1rem;
// }

// .keypad-grid {
//   display: grid;
//   grid-template-columns: repeat(3, 1fr);
//   gap: 0.5rem;
// }

// .keypad-grid button {
//   padding: 1rem;
//   font-size: 1.2rem;
//   border: none;
//   background: #f0f0f0;
//   border-radius: 8px;
//   cursor: pointer;
// }

// .confirm-btn {
//   grid-row: span 2;
//   background: teal;
//   color: white;
// }

//           `}
//       </style>
//     </>
//   );
// };

// export default NtxTest;

import React, { useState, useEffect, useRef } from 'react';

const NtxTest = ({ onSubmit }: { onSubmit: any }) => {
  const [input, setInput] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);

  const handleClick = (value: string) => {
    if (value === '.' && input.includes('.')) return;
    setInput(prev => prev + value);
  };

  const handleBackspace = () => {
    setInput(prev => prev.slice(0, -1));
  };

  const handleClear = () => {
    setInput('');
  };

  const handleSubmit = () => {
    onSubmit(input);
  };

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      const { key } = e;

      if (!isNaN(Number(key))) {
        setInput(prev => prev + key);
      } else if (key === '.' && !input.includes('.')) {
        setInput(prev => prev + key);
      } else if (key === 'Backspace') {
        handleBackspace();
      } else if (key === 'Enter') {
        handleSubmit();
      } else if (key === 'Escape') {
        handleClear();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [input]);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <>
      <div className='keypad-container'>
        <input ref={inputRef} className='display-input' value={input} readOnly />

        <div className='keypad-grid'>
          <button onClick={handleBackspace}>⌫</button>
          <button onClick={handleClear}>✖</button>
          <button className='confirm-btn' onClick={handleSubmit}>
            ✔
          </button>

          {[9, 8, 7, 6, 5, 4, 3, 2, 1].map(num => (
            <button key={num} onClick={() => handleClick(num.toString())}>
              {num}
            </button>
          ))}

          <button onClick={() => handleClick('.')}>.</button>
          <button onClick={() => handleClick('0')}>0</button>
        </div>
      </div>

      <style>
        {`
          .keypad-container {
            width: 300px;
            padding: 1rem;
            background: white;
            border-radius: 10px;
            box-shadow: 0 0 10px #ccc;
          }

          .display-input {
            width: 100%;
            font-size: 1.5rem;
            text-align: right;
            padding: 0.5rem;
            border: 2px solid teal;
            border-radius: 5px;
            margin-bottom: 1rem;
          }

          .keypad-grid {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 0.5rem;
          }

          .keypad-grid button {
            padding: 1rem;
            font-size: 1.2rem;
            border: none;
            background: #f0f0f0;
            border-radius: 8px;
            cursor: pointer;
          }

          .confirm-btn {
            grid-row: span 2;
            background: teal;
            color: white;
          }
        `}
      </style>
    </>
  );
};

export default NtxTest;
